module.exports = __webpack_public_path__ + "static/media/logo.8d2d1b61.png";